module.exports = {"helmetTitle":"Veloe - Editar Informações Gerenciais","titleModalError":"Erro ao excluir informação"}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/EditIdentifiers/data.json
// module id = 1814
// module chunks = 0